export const TUTORIAL_VIDEO_URL =
  "https://drive.google.com/file/d/1zMt5gBR8EaLRodlmm7Rd52Dl3AJHEpa6/preview";

export const SNACKBAR_SUCCESS_TEXT = "Invites sent successfully";
